"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldHideSchedulingHelpMessages = exports.isDirectBookRenderedInDrawer = exports.getUseProviderInsuranceOnRegForm = void 0;
const isDirectBookRenderedInDrawer = config => {
  return config?.render_type === 'drawer';
};
exports.isDirectBookRenderedInDrawer = isDirectBookRenderedInDrawer;
const shouldHideSchedulingHelpMessages = config => {
  return config?.enable_hide_scheduling_help_messages === true;
};
exports.shouldHideSchedulingHelpMessages = shouldHideSchedulingHelpMessages;
const getUseProviderInsuranceOnRegForm = config => {
  return config?.use_provider_insurance_on_reg_form === true;
};
exports.getUseProviderInsuranceOnRegForm = getUseProviderInsuranceOnRegForm;